const removeItem = (setFieldValue, products, type, i) => {
  const updatedProducts = products;

  updatedProducts.splice(i, 1);

  setFieldValue(type, updatedProducts);
};

export default removeItem;
